// src/config/api.js
export const API_BASE_URL = 'https://cleaner-automation-936dbbf97f9e.herokuapp.com';

export const endpoints = {
  // Existing endpoints
  checkQuestion: '/api/check-question',
  getAnswer: '/api/get-answer',
  updateAnswer: '/api/update-answer',
  addQnA: '/api/add-qna',
  scrapeWebsite: '/api/scrape-website',
  purchasePhoneNumber: '/api/phone-numbers/purchase',
  finalizeSetup: '/api/account/setup',
  generateVariations: '/api/generate-variations',
  updatePathway: '/api/update-pathway',
  generateTriggers: '/api/generate-triggers',
  generateQuestions: '/api/generate-questions',
  generateSopIntent: '/api/generate-sop-intent',
  updateVoicePreference: '/api/update-voice-preference',
  generateStaticMap: '/api/generate-static-map',
  generateLocationZipcodes: '/api/generate-location-zipcodes',

  // Add new SOP endpoints
  updateSopPathway: '/api/update-sop-pathway',

  // Chat endpoints
  chatManual: '/api/chat/manual',

  //Onboarding
  searchPhoneNumbers: '/api/twilio/number/search',
  verifyWebsite: '/api/onboarding/website/verify',
  duplicatePathway: '/api/pathways/duplicate-default',
  scrapeLocationData: '/api/account/scrape/location-business-data',
  knowledgeQuery: '/api/onboarding/integration/knowledge',
  onboardingScrapeWebsite: '/api/onboarding/scrape',

  //Locations
  updateLocationContext: '/api/locations/context/new',

  //Test Endpoints for Actions
  testEmail: '/api/email/complex-action',
  testSms: '/api/sms/complex-action',
  testApi: '/api/external/complex-action',

  //Payments with Stripe
  createPaymentIntent: '/api/create-payment-intent',
  createSubscription: '/api/subscriptions/create',

  // Questions completion - updated endpoints
  generateSuggestionQuestions: (suggestionId) => `/api/analysis/suggestions/${suggestionId}/generate-questions`,
  completeQuestions: (id) => `/api/analysis/suggestions/${id}/complete-questions`,

  // Add Analysis endpoints
  analysisCoverage: '/api/analysis/coverage',
  coverageSetting: '/api/analysis/coverage-setting', // New endpoint for individual setting analysis
  conflictDetection: '/api/analysis/conflicts',
  coverageRefresh: '/api/analysis/coverage-refresh', // Full account coverage refresh

  // Voice Upload endpoints
  voiceTranscribe: '/api/brain/voice/transcribe',
  voiceAnalyze: '/api/brain/voice/analyze',
  voiceSaveSettings: '/api/brain/voice/save-settings',

  // V2 Integration Management endpoints
  integrationsConnections: '/api/integrations/connections',
  integrationsExecuteTool: (connectionId) => `/api/integrations/connections/${connectionId}/execute-tool`,

  // Admin integrations endpoints
  adminProvidersGet: '/api/integrations/providers',
  adminProvidersPost: '/api/integrations/providers',
  adminProviderConfig: (slug) => `/api/integrations/providers/${slug}/config`,
  adminProviderConfigPost: (slug) => `/api/integrations/providers/${slug}/config`,
  adminTestConnection: '/api/integrations/test-connection',
  adminAuthMethods: '/api/integrations/auth-methods',

  // AI Agent endpoints
  aiParseApiDocs: '/api/integrations/ai/parse-api-docs',

  // Vapi endpoints
  vapiSquad: (phoneNumber) => `/api/vapi/v2/${phoneNumber}`,
};